import { motion } from "framer-motion";
import { Instagram } from "lucide-react";

const IG_URL = "https://instagram.com/grill_enforcers";

export default function SiteFooter() {
    return (
        <footer
            data-testid="site-footer"
            className="relative overflow-hidden border-t border-[#2A2A36] bg-[#060608] px-5 pb-10 pt-20 sm:px-10 sm:pt-28 lg:px-16"
        >
            <div className="noise-layer" />
            <div className="mx-auto max-w-[1380px]">
                <div className="flex flex-col gap-10 lg:flex-row lg:items-end lg:justify-between">
                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                    >
                        <img
                            src="/assets/asset2.png"
                            alt="Grill Enforcers logo"
                            className="h-16 w-auto rounded-sm border border-[#2A2A36] sm:h-20"
                        />
                        <h2 className="font-cond mt-6 text-5xl font-extrabold uppercase leading-[0.85] tracking-tight text-[#F2F2F7] sm:text-7xl">
                            Hungry?
                            <br />
                            <span className="text-outline-ember">Enforce it.</span>
                        </h2>
                    </motion.div>
                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.15, duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                        className="flex flex-col gap-4 lg:items-end"
                    >
                        <a
                            href={IG_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-instagram-button"
                            className="group flex items-center gap-3 border-2 border-[#2A2A36] px-6 py-3.5 font-cond text-xl font-bold uppercase tracking-wide text-[#F2F2F7] transition-[border-color,color,transform] duration-150 hover:-translate-y-0.5 hover:border-[#FF3B30] hover:text-[#FF3B30]"
                        >
                            <Instagram className="h-4 w-4" strokeWidth={2.5} />
                            @GRILL_ENFORCERS
                        </a>
                        <span className="font-jbmono text-[11px] uppercase tracking-[0.2em] text-[#A1A1B2]/70">
                            DM to order — $40 — red / white / black / blue lace
                        </span>
                    </motion.div>
                </div>

                <div className="mt-16 flex flex-col gap-3 border-t border-[#2A2A36] pt-6 sm:flex-row sm:items-center sm:justify-between">
                    <span className="font-jbmono text-[9px] uppercase tracking-[0.15em] text-[#A1A1B2]/50">
                        © 2026 GRILL ENFORCERS — MADE FROM 100% RECYCLED HOCKEY STICKS
                    </span>
                    <span className="font-jbmono text-[9px] uppercase tracking-[0.15em] text-[#A1A1B2]/50">
                        NO PATTIES WERE HARMED IN THE ARCADE
                    </span>
                </div>
            </div>
        </footer>
    );
}
